import apiService from "../../../../../../../api/apiService";
import { Container } from "@mui/material";
import SelectEnvButton from "../../SelectEnvButton";
import { useEffect, useState } from "react";
import EnvironmentContext from "../../EnvironmentContext";
import { useContext } from "react";
import Box from "@mui/material/Box";
import StepperContext from "../StepperContext";
import { useForm } from "react-hook-form";
import { useQuery } from "react-query";
import { userDetails } from "../../../../../../../utils/const/query-key";
import ModalContext from "../../../../envResultsTable/ModalContext";
import { StepContainer, RadioWrapper, InputRadio, ScenarioLabel, ScenarioSpanLabel, Button, P } from './first-step.style';


const selfTrainingUrl = process.env.REACT_APP_SELF_TRAINING_URL;

const FirstStep = (props) => {
    const { scenario, setScenario } = props;
    const [isActive, setIsActive] = useState(false);
    const { environment, setEnvironment } = useContext(EnvironmentContext);
    const { activeStep, handleNext, handleBack } = useContext(StepperContext);
    const { setContentMessage } = useContext(ModalContext);
    const { register, handleSubmit } = useForm();
    const { data: getUserData } = useQuery(userDetails, () =>
        apiService.getUser()
        , { staleTime: Infinity }
    );
    const { departmentId } = useContext(StepperContext);
    const showSelfTraining = departmentId === '82';


    useEffect(() => {
        if (environment.scenario !== "") {
            setIsActive(true);
            setScenario(environment.scenario);
        }
    }, [environment.scenario]);


    useEffect(() => {
        setContentMessage("");
    }, [])

    const handleClick = () => {
        setIsActive((current) => !current);
    }
    const handleScenario = (e) => {
        setScenario(e.target.id);
    }
    const handleHandsOn = () => {
        apiService.getHandsOnApi().then(res => window.open(res, "_blank"));
        props.handleBack();
    }

    const handleSelfTrainingClick = () => {
        window.open(selfTrainingUrl, "_blank");
    };

    const onSubmit = (data) => {
        setEnvironment(prevState => {
            return {
                ...prevState,
                scenario: scenario,
                environment_type: scenario === "selfTraining" ? "training" : "Demo"
            }
        })
    }


    return (
        <form onSubmit={handleSubmit(onSubmit)} id={"form_first_step"}>
            <Container>
                <StepContainer>
                    <SelectEnvButton
                        isActive={isActive || scenario !== ""}
                        onClick={handleClick}
                        title={"Demo"}
                    />
                    {getUserData?.isCpSales && (
                        <SelectEnvButton title={"Classroom Training"} onClick={handleHandsOn} />
                    )}
                    {showSelfTraining && (
                        <SelectEnvButton
                            title="Self Training"
                            onClick={handleSelfTrainingClick}
                        />
                    )}
                </StepContainer>
            </Container>
            <div style={{ "marginBottom": "15px" }}>
                {
                    (isActive || scenario !== "") &&
                    <div>
                        <Container>
                            <div style={{ "marginBottom": "15px" }}>Select Scenario</div>
                            {(getUserData?.isCpSales || getUserData?.isPartner) &&
                                <RadioWrapper onClick={handleScenario} checked={scenario === "customerDemo"}
                                    id={"customerDemo"} value={scenario} htmlFor={"customerDemo"}>
                                    <InputRadio type={"radio"}
                                        name={"radio"}
                                        id={"customerDemo"}
                                        label={"customerDemo"}
                                        onClick={handleScenario}
                                        value={"customerDemo"}
                                        checked={scenario === "customerDemo"}
                                        {...register("scenario")}
                                    />
                                    <ScenarioLabel htmlFor={"customerDemo"} id={"customerDemo"} value={scenario}>
                                        <ScenarioSpanLabel value={scenario} checked={scenario === "customerDemo"}
                                            id={"customerDemo"}>Customer/Partner
                                            Demo</ScenarioSpanLabel>
                                        <P value={scenario} id={"customerDemo"}>Demo for a customer/partner facing
                                            engagement</P>
                                    </ScenarioLabel>
                                </RadioWrapper>
                            }
                            <RadioWrapper onClick={handleScenario} value={scenario}
                                checked={scenario === "preparationDemo"}
                                id={"preparationDemo"}
                            >
                                <InputRadio type={"radio"}
                                    id={"preparationDemo"}
                                    name={"radio"}
                                    label={"preparationDemo"}
                                    onClick={handleScenario}
                                    checked={scenario === "preparationDemo"}
                                    value={"preparationDemo"}
                                    {...register("scenario")}
                                />
                                <ScenarioLabel value={scenario} htmlFor={"preparationDemo"} id={"preparationDemo"}>
                                    <ScenarioSpanLabel value={scenario} checked={scenario === "preparationDemo"}
                                        id={"preparationDemo"}>
                                        Preparation Demo
                                    </ScenarioSpanLabel>
                                    <P value={scenario} id={"preparationDemo"}>Meeting preparation/demo environment
                                        sharing</P>
                                </ScenarioLabel>
                            </RadioWrapper>
                            <RadioWrapper onClick={handleScenario} value={scenario}
                                          checked={scenario === "selfTraining"}
                                          id={"selfTraining"}
                            >
                                <InputRadio type={"radio"}
                                            id={"selfTraining"}
                                            name={"radio"}
                                            label={"selfTraining"}
                                            onClick={handleScenario}
                                            checked={scenario === "selfTraining"}
                                            value={"selfTraining"}
                                            {...register("scenario")}
                                />
                                <ScenarioLabel value={scenario} htmlFor={"selfTraining"} id={"selfTraining"}>
                                    <ScenarioSpanLabel value={scenario} checked={scenario === "selfTraining"}
                                                       id={"selfTraining"}>
                                        Self Learning
                                    </ScenarioSpanLabel>
                                    <P value={scenario} id={"selfTraining"}>Hands-on practice for self-learning and skill development</P>
                                </ScenarioLabel>
                            </RadioWrapper>
                        </Container>
                    </div>
                }
            </div>
            <Container>
                <Box sx={{ mb: 2 }}>
                    <StepContainer align={"left"}>
                        <Button
                            className={'next'}
                            id={'next'}
                            onClick={handleNext}
                            sx={{ mt: 1, mr: 1 }}
                            disabled={scenario === ""}
                            theme={{ main: scenario === "" ? "none" : "" }}
                            type={"submit"}
                        >
                            Next
                        </Button>
                        <Button
                            onClick={handleBack}
                            sx={{ mt: 1, mr: 1 }}
                            id={"back"}
                        >
                            {activeStep === 0 ? 'Cancel' : 'Back'}
                        </Button>
                    </StepContainer>
                </Box>
            </Container>
        </form>
    )
}

export default FirstStep;
